/**
 * Route definitions for the Jobs module.
 * Lazily loads page components for jobs list, job details, and job ticket details.
 */
import createFeatureRoutes from '@/common/presentation/components/MainRouteHelper/MainRouteHelper';

const JobsRoutes = createFeatureRoutes(
  'jobs',
  {
    list: () => import('../presentation/pages/JobsPage'),
    details: () => import('../presentation/pages/JobDetailsWrapper'),
    ticketOverviewDetails: () => import('../../raptorjob/presentation/pages/JobTicketOverviewDetailsPage')
  },
  [
    { path: '', pageKey: 'list' },
    { path: 'create', pageKey: 'details' },
    { path: ':id', pageKey: 'details' },
    { path: ':jobId/job-tickets/:ticketId/details', pageKey: 'ticketOverviewDetails' }
  ]
);

export const jobsRoutesMap = {
  ticketOverviewDetails: (jobId: string, ticketId: string) =>
    `/jobs/${jobId}/job-tickets/${ticketId}/details?module=jobs&submodule=dispatch&tab=ticket`
};

export default JobsRoutes;
